import axios from 'axios';
import {Message} from 'view-design';
import config from '@/config';
import {getCookies, removeCookies} from "@/utils/helper";
import router from '@/router'

const service = axios.create({
    baseURL: config.apiUrl,
    timeout: 100000 // 请求超时时间
})


service.interceptors.request.use(
    config=>{
        const token = getCookies('token')
        if(token){
            config.headers['authori-zation-crm'] = token
        } else {
            // router.replace({ path: '/login' })
        }
        return config;
    },
    error=>{
        return Promise.reject(error);
    }
)

service.interceptors.response.use(
    response=>{

        let code = response.data ? response.data.code : 0
        switch (code) {
            case 101:
                localStorage.clear()
                removeCookies('token')
                router.replace({ path: '/login' })
                break
            default:
                return response.data
        }
    },
    error=>{
        console.log(error)

        removeCookies('token')
        if(router.currentRoute.query.from == 'h5'){
            router.replace({ path: `/login?order_id=${router.currentRoute.query.order_id}&customer_id=${router.currentRoute.query.customer_id}&type=6&from=h5` })
        }else {
            router.replace({ path: '/login' })
        }
        if (typeof error.response == "undefined") {
            Message.error("服务器异常");
        }
        return Promise.reject(error);
    }

)

export default service;
